// @ts-check
import React from "react"
import { isHolidayAvailable } from "../../../utils/vacation.utils"
import { EditedAfterFinishedBadge } from "../CellReportBadges.molecule"
import { numberFormatter } from "../../../utils/numbers.utils"
import { isTaskReportItem } from "../../../utils/report.utils"

/**
 * @param {import("./BilledTimeCell.molecule").BilledTimeCellProps<import("../../../services/reports.service.types").AnyTaskReportItem>} props
 * @returns {JSX.Element | null}
 */

export function BilledTimeCell(props) {
  const { ctx, teamMemberSchemaRules, teamMemberWorkAnniversaryDate } = props
  const { row, getValue } = ctx
  const rowData = row.original
  const billedTime = getValue()

  const isTask = isTaskReportItem(rowData)
  const isGrouped = row.getIsGrouped()

  let isHolidayUnlocked = false

  if (isTask && "isHoliday" in rowData) {
    isHolidayUnlocked =
      teamMemberSchemaRules && teamMemberWorkAnniversaryDate ?
        isHolidayAvailable({
          idTypeOfHoliday: rowData?.idTypeOfHoliday,
          idHolidaySchemaType: rowData?.holidaySchemaType,
          teamMemberSchemaRules,
          isHoliday: rowData?.isHoliday,
          workAnniversaryDate: teamMemberWorkAnniversaryDate,
          currentDate: rowData?.date,
        })
      : false
  }

  const isDayOff =
    ("isVacationDay" in rowData && rowData?.isVacationDay) || isHolidayUnlocked

  const displayValue =
    isDayOff && billedTime === 0 ? "-" : numberFormatter(billedTime)

  const showBadge =
    isTask &&
    rowData.clientIsBillable &&
    !isGrouped &&
    rowData.billedTimeModifiedAfterFinished

  const isNA =
    billedTime === null || (!isGrouped && isTask && !rowData.clientIsBillable)

  return (
    <div className={`flex gap-1`}>
      {isNA ?
        <span className="opacity-30">N/A</span>
      : <span className={isGrouped ? "font-bold" : ""}>{displayValue}</span>}
      {showBadge ?
        <EditedAfterFinishedBadge tooltipValue="Los tiempos registrados fueron editados después de finalizar el día." />
      : null}
    </div>
  )
}
